import Cookie from 'js-cookie';

import { ACCOUNT_COOKIE } from '../settings/account';

export function getIsConnected() {
  return !!getName();
}

export function getName() {
  let name = '';
  let cookieData = Cookie.get(ACCOUNT_COOKIE);
  if (cookieData) {
    cookieData = JSON.parse(cookieData);
    name = cookieData.name;
  }
  return name;
}



// WEBPACK FOOTER //
// ./src/actions/account.js